import { Button, ButtonContainer } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";

export const WizardButtons = () => {
    const { goToPreviousStep, currentStep, steps, setIsSkipSteps, isEdit } = useMatchMakerWizard();
    const { t } = useTranslation("matchmakerwizard");
    return (
        <ButtonContainer nav>
            {!isEdit ? (
                <>
                    {((currentStep.id === steps[0].id && currentStep.path?.id !== steps[0].paths[0].id) ||
                        currentStep.id !== steps[0].id) && (
                        <Button secondary type="button" id="BackButton" testId="backbutton" onClick={goToPreviousStep}>
                            {t("matchmakerwizard:back-button")}
                        </Button>
                    )}
                    {((currentStep.id === steps[0].id && currentStep.path.id !== steps[0].paths[1].id)) && (
                        <Button type="submit" id="NextButton" testId="nextbutton">
                            {t("matchmakerwizard:next-button")}
                        </Button>
                    )}
                    {(currentStep.id !== steps[0].id && currentStep.id !== steps[2].id)&&(
                        <Button type="submit" id="NextButton" testId="nextbutton">
                            {t("matchmakerwizard:check-details")}
                        </Button>
                    )}
                    {currentStep.id === steps[0].id && currentStep.path.id === steps[0].paths[1].id && (
                        <>
                            <Button type="submit" id="NextButton" testId="nextbutton">
                                {t("matchmakerwizard:provide-further-information-button")}
                            </Button>
                            <Button
                                type="submit"
                                id="JumpStepsButton"
                                testId="jumpstepsbutton"
                                onClick={() => {
                                    setIsSkipSteps(true);
                                }}
                            >
                                {t("matchmakerwizard:send-questionnaire-button")}
                            </Button>
                        </>
                    )}
                    {currentStep.id === steps[2].id && (
                        <>
                            <Button type="submit" testId="sendrequestbutton" id="SubmitButton">
                                {t("matchmakerwizard:send-questionnaire-button")}
                            </Button>
                        </>
                    )}
                </>
            ) : (
                <>
                    <Button type="submit" testId="savebutton" id="SaveButton">
                        {t("matchmakerwizard:save-button")}
                    </Button>
                </>
            )}
        </ButtonContainer>
    );
};

export default WizardButtons;
